export const translateMenu = {
  pt: {
    menu: {
      sobre: "Sobre",
      tecnologias: "Tecnologias",
      projetos: "Projetos",
      experiencia: "Experiência",
      educao: "Educação",
      contato: "Contato"
    }
  },
  en: {
    menu: {
      sobre: "About",
      tecnologias: "Technologies",
      projetos: "Projects",
      experiencia: "Experience",
      educacao: "Education",
      contato: "Contact"
    }
  }
};